import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import PhoneInput from 'react-phone-number-input';
import Select from 'react-select';
import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css';
import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import { getTokenInfo } from '../../../../UseToken';
import Loader from '../../../Loader/Loader';
import Swal from 'sweetalert2'
import Hosts from '../../../../Hosts';
import UseSidebar from '../../../../UseSidebar';
import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	obter_paises_em_pt,
	pattern_email,
	handle_compressed_image_upload,
	set_language,
	translate,
	repo_img_link,
} from '../../../../Utils';

import { language } from './Language';
import { color } from '../../../WEBContent/Color';

const modalStyles = {
	modalOverlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		backgroundColor: color.corShadow.rgba2,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: 1000,
	},
	modalContent: {
		backgroundColor: color.cor3.hexa,
		padding: '20px',
		borderRadius: '10px',
		width: '600px',
		maxWidth: '90%',
		textAlign: 'center',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		position: 'relative',
		overflow: 'hidden',
	},
	taskListContainer: {
		flex: 1,
		width: '100%',
		padding: '10px 15px',
		textAlign: 'start',
	},
	buttonContainer: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		marginTop: '15px',
	},
	closeButton: {
		padding: '10px 20px',
		border: 'none',
		borderRadius: '5px',
		cursor: 'pointer',
		backgroundColor: color.cor1.hexa,
		fontSize: '16px',
	},
};

const EPOCA = {
	MES_CORTE: 6,

	obterAnoEpoca(data = new Date()) {
		// const ano = data.getFullYear()
		// const mes = data.getMonth()
		// return mes >= this.MES_CORTE ? ano : ano - 1
	},

	formatar(ano_inicio) {
		return `${ano_inicio}/${ano_inicio + 1}`
	},

	obterEpocaAtual(data = new Date()) {
		return this.formatar(this.obterAnoEpoca(data))
	},

	podeEditar(epoca, profile, epoca_atual = this.obterEpocaAtual()) {
		if (!epoca || epoca === epoca_atual) return true
		return profile === 'Administrador' || profile === 'Gestor de Conteúdos'
	},
}

const modalidades_lista = [
	{ value: 'ski_de_fundo', label: 'Esqui de Fundo' },
	{ value: 'curling', label: 'Curling' },
	{ value: 'ski_alpino', label: 'Esqui Alpino' },
	{ value: 'bobsled', label: 'Bobsled' },
	{ value: 'hoquei_no_gelo', label: 'Hóquei no Gelo' },
	{ value: 'luge', label: 'Luge' },
	{ value: 'snowboard', label: 'Snowboard' },
	{ value: 'skeleton', label: 'Skeleton' },
	{ value: 'patinagem_artistica', label: 'Patinagem Artística' },
	{ value: 'patinagem_de_velocidade', label: 'Patinagem de Velocidade' },
	{ value: 'ski_freestyle', label: 'Esqui Freestyle' },
	{ value: 'biatlo', label: 'Biatlo' },
];

const tipo_competicao_lista = [
	{ value: 'campeonato_nacional', label: 'Campeonato Nacional' },
	{ value: 'campeonato_regional', label: 'Campeonato Regional' },
	{ value: 'taca', label: 'Taça' },
	{ value: 'torneio', label: 'Torneio' },
	{ value: 'internacional', label: 'Internacional' },
	{ value: 'outro', label: 'Outro' },
];

const tipo_classificacao_lista = [
	{ value: 'jogos', label: 'Campenato / Taça' },
	// { value: 'resultado', label: 'Resultado' },
	{ value: 'tempo', label: 'Tempo' },
	{ value: 'pontos', label: 'Pontos' },
];

let year = new Date().getFullYear();

const ESCALOES_GERAL = [
	{ id: 'U10', label: 'U10', min: (parseInt(year) - 9), max: Infinity },
	{ id: 'U12', label: 'U12', min: (parseInt(year) - 11), max: (parseInt(year) - 10) },
	{ id: 'U14', label: 'U14', min: (parseInt(year) - 13), max: (parseInt(year) - 12) },
	{ id: 'U16', label: 'U16', min: (parseInt(year) - 15), max: (parseInt(year) - 14) },
	{ id: 'U18', label: 'U18', min: (parseInt(year) - 17), max: (parseInt(year) - 16) },
	{ id: 'U21', label: 'U21', min: (parseInt(year) - 20), max: (parseInt(year) - 17) },
	{ id: 'SENIOR', label: 'Sénior', min: (parseInt(year) - 34), max: (parseInt(year) - 21) },
	{ id: 'M35', label: 'M35', min: (parseInt(year) - 54), max: (parseInt(year) - 35) },
	{ id: 'M55', label: 'M55', min: -Infinity, max: (parseInt(year) - 55) },
];

const ESCALOES_SNOWBOARD = [
	{ id: 'U9', label: 'U9 (kids)', min: (parseInt(year) - 8), max: Infinity },
	{ id: 'U11', label: 'U11 (SuperGrom)', min: (parseInt(year) - 10), max: (parseInt(year) - 9) },
	{ id: 'U13', label: 'U13 (SuperGrom)', min: (parseInt(year) - 12), max: (parseInt(year) - 11) },
	{ id: 'U15', label: 'U15 (Grom)', min: (parseInt(year) - 14), max: (parseInt(year) - 13) },
	{ id: 'U18_ROOKIE', label: 'U18 (Rookie)', min: (parseInt(year) - 17), max: (parseInt(year) - 15) },
	{ id: 'ABSOLUTO', label: 'Absoluto', min: (parseInt(year) - 42), max: (parseInt(year) - 18) },
	{ id: 'M40', label: 'M40 (Master)', min: -Infinity, max: (parseInt(year) - 43) },
];

const ESCALOES_PATINAGEM = [
	{ id: 'PRE_INICIADO', label: 'Pré-Iniciado' },
	{ id: 'NOVATOS', label: 'Novatos' },
	{ id: 'JUNIORES', label: 'Juniores' },
	{ id: 'SENIORES', label: 'Seniores' },
	{ id: 'ADULTOS', label: 'Adultos' },
];

const gerar_tabela_escaloes_por_idade = (idades_config, anoEpoca) => {
	return idades_config.map(e => ({
		id: e.id,
		label: e.label,
		min: e.idade_max === Infinity ? -Infinity : anoEpoca - e.idade_max,
		max: e.idade_min === -Infinity ? Infinity : anoEpoca - e.idade_min,
	}))
};

const escaloes_lista = [
	...ESCALOES_GERAL.map(e => ({ value: e.id, label: e.label })),
	...ESCALOES_SNOWBOARD.map(e => ({ value: e.id, label: `${e.label} (Snowboard)` })),
	...ESCALOES_PATINAGEM.map(e => ({ value: e.id, label: `${e.label} (Patinagem)` })),
];

const anoNascimento = (birthday) => {
	if (!birthday) return null;
	const ano = parseInt(String(birthday).slice(0, 4), 10);
	return Number.isNaN(ano) ? null : ano;
};

const escalaoPorAno = (ano, tabela) => {
	if (ano === null) return '';
	const item = tabela.find(e => ano >= e.min && ano <= e.max);
	return item ? item.id : '';
};

const idadeReferencia = (birthday, anoEpoca) => {
	if (!birthday) return null;
	const nascimento = new Date(birthday);
	const referencia = new Date(anoEpoca, 6, 1);
	let idade = referencia.getFullYear() - nascimento.getFullYear();
	const diffMes = referencia.getMonth() - nascimento.getMonth();
	if (diffMes < 0 || (diffMes === 0 && referencia.getDate() < nascimento.getDate())) idade--;
	return idade;
};

const escalaoPorIdade = (idade) => {
	if (idade === null) return '';
	if (idade >= 28) return 'ADULTOS';
	if (idade > 13 && idade <= 18) return 'JUNIORES';
	if (idade >= 8 && idade <= 13) return 'NOVATOS';
	if (idade >= 17) return 'SENIORES';
	if (idade >= 6) return 'PRE_INICIADO';
	return '';
};

const detectarGrupoModalidade = (modalidade_value) => {
	const v = (modalidade_value ?? '').toString().toLowerCase();
	if (v.includes('patinacao')) return 'patinagem';
	if (v.includes('snowboard')) return 'snowboard';
	return 'geral';
};

const calcular_escalao_para_modalidade = (entidade, modalidade_value) => {
	const birthday = entidade?.info?.birthday ?? entidade?.birthday
	const grupo = detectarGrupoModalidade(modalidade_value)
	const anoEpoca = EPOCA.obterAnoEpoca()

	if (grupo === 'patinagem') {
		return escalaoPorIdade(idadeReferencia(birthday, anoEpoca))
	}
	const idades_config = grupo === 'snowboard' ? ESCALOES_SNOWBOARD : ESCALOES_GERAL
	const tabela = gerar_tabela_escaloes_por_idade(idades_config, anoEpoca)
	return escalaoPorAno(anoNascimento(birthday), tabela)
};

const get_modalidades_entidade = (entidade) => {
	const mods = entidade?.info?.modalidades ?? entidade?.modalidades
	return Array.isArray(mods) ? mods.map(m => (m.value ?? m)) : []
};

const get_overlapping_modalidades = (entidade, modalidades_competicao) => {
	const mods_entidade = get_modalidades_entidade(entidade)
	if (!modalidades_competicao || modalidades_competicao.length === 0) return mods_entidade
	return mods_entidade.filter(m => modalidades_competicao.includes(m))
};

const entidade_pratica_modalidade = (entidade, modalidades_competicao) => {
	if (!modalidades_competicao || modalidades_competicao.length === 0) return true
	return get_overlapping_modalidades(entidade, modalidades_competicao).length > 0
};

const calcular_escalao_entidade = (entidade, modalidades_competicao) => {
	const overlapping = get_overlapping_modalidades(entidade, modalidades_competicao)
	return calcular_escalao_para_modalidade(entidade, overlapping[0])
};

const tempo_para_segundos = (valor) => {
	if (!valor) return 0
	const partes = String(valor).split(':').map(n => parseInt(n, 10) || 0)
	while (partes.length < 3) partes.unshift(0)
	const [h, m, s] = partes.slice(-3)
	return h * 3600 + m * 60 + s
}

const entidade_esta_no_escalao = (entidade, modalidades_competicao, escaloes_competicao) => {
	if (!escaloes_competicao || escaloes_competicao.length === 0) return true
	const overlapping = get_overlapping_modalidades(entidade, modalidades_competicao)
	if (overlapping.length === 0) return false
	return overlapping.some(m => escaloes_competicao.includes(calcular_escalao_para_modalidade(entidade, m)))
};


export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const permissions = useRef(null);
	const [, set_permissions_trigger] = useState(0);

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);
	const [is_edit, set_is_edit] = useState(false);

	const [countries, set_countries] = useState([]);

	const [files_doc, set_files_doc] = useState([]);
	const [img_loader, set_img_loader] = useState([]);

	const [files_image, set_files_image] = useState([]);
	const [image_base64, set_image_base64] = useState([]);
	const [photo_base64, set_photo_base64] = useState('');

	const [showClubeModal, setShowClubeModal] = useState(false);
	const [clubeSearch, setClubeSearch] = useState('');
	const [clubeResults, setClubeResults] = useState([]);
	const [clubeLoading, setClubeLoading] = useState(false);
	const [selectedClubeToInscrever, setSelectedClubeToInscrever] = useState(null);

	const [showAtletaModal, setShowAtletaModal] = useState(false);
	const [atletaSearch, setAtletaSearch] = useState('');
	const [atletaResults, setAtletaResults] = useState([]);
	const [atletaLoading, setAtletaLoading] = useState(false);
	const [selectedAtletaToInscrever, setSelectedAtletaToInscrever] = useState(null);
	const [selected_clube_inscrito, set_selected_clube_inscrito] = useState(null);
	const [clube_ids, set_clube_ids] = useState(new Set());
	const [clubes, set_clubes] = useState([]);
	const [temporadas_lista, set_temporadas_lista] = useState([]);
	const [clubes_da_epoca, set_clubes_da_epoca] = useState([]);
	const [jogos_lista, set_jogos_lista] = useState([]);

	const [pode_editar, set_pode_editar] = useState(true);

	const fetch_clube_ids = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/Clube`)
			if(Array.isArray(res.data)) {
				set_clubes(res.data)
				set_clube_ids(new Set((res.data || []).map(e => String(e.id))))
			}
		} catch (error) {
			console.error('Erro ao carregar lista de clubes:', error)
		}
	}

	useEffect(() => {
		fetch_clube_ids()
	}, [])

	const fetch_temporadas = async (type) => {
		let res = await reqGET(`${api_crud_base}/intranet/components/type/${getTokenInfo().companycode}/temporada`)
		let result = []

		if (res.data !== undefined) {
			for await (let el of res.data) {

				if (!el.info.avaiable) continue

				let aux = {
					id: el.id,
					name: translate(el.info.title, 'pt')
				}

				result.push(aux)
			}
		}

		return result
	}

	const fetch_jogos = async (type) => {
		let res = await reqGET(`${api_crud_base}/intranet/components/type/${getTokenInfo().companycode}/jogos`)
		let result = []

		if (res.data !== undefined) {
			for await (let el of res.data) {

				if (!el.info.available) continue
				if (el?.info?.competition === undefined) continue
				if (parseInt(el.info.competition) !== parseInt(dados.current.id)) continue

				result.push(el)
			}
		}

		return result
	}

	const order_array_desc = (array) => {
		return array.sort((a, b) => {
			return b.name.localeCompare(a.name, undefined, { numeric: true, sensitivity: 'base' })
		});
	}
	const order_array_data_jogo_asc = (array) => {
		return array.sort((a, b) => {
			return a.info.data_jogo.localeCompare(b.info.data_jogo, undefined, { numeric: false, sensitivity: 'base' })
		});
	}
	const order_array_hora_jogo_asc = (array) => {
		return array.sort((a, b) => {
			return a.info.hora_inicio.localeCompare(b.info.hora_inicio, undefined, { numeric: false, sensitivity: 'base' })
		});
	}

	const soma_periodos = (obj) => {

		if(obj?.p1 !== undefined && obj?.p1 !== null && obj?.p1 !== '') {
			let p1 = parseInt(obj?.p1, 10) || 0
			let p2 = parseInt(obj?.p2, 10) || 0
			let p3 = parseInt(obj?.p3, 10) || 0
			let ot = parseInt(obj?.ot, 10) || 0
			return p1 + p2 + p3 + ot
		}
		else {
			return ''
		}

	}

	let get_permissions = async (e, sidebar) => {
		let handleSingleCheck = async (e, sidebar) => {
			const name = e;

			let ver_submenu = async (node) => {
				if (node.submenu.length !== 0) {

					for await (let subitem of node.submenu) {

						if (subitem.path === name) {

							let aux = {}
							if (permissions.current !== null) {
								aux = permissions.current

								if (aux.create !== true) {
									aux.create = subitem.create
								}
								if (aux.edit !== true) {
									aux.edit = subitem.edit
								}
								if (aux.remove !== true) {
									aux.remove = subitem.remove
								}
							}
							else {
								aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
							}

							permissions.current = aux
							set_permissions_trigger(v => v + 1)
						}
						else {
							await ver_submenu(subitem)
						}

					}
				}
			}

			for await (let node of sidebar) {
				if (node.path === name) {

					let aux = {}
					if (permissions.current !== null) {
						aux = permissions.current

						if (aux.create !== true) {
							aux.create = node.create
						}
						if (aux.edit !== true) {
							aux.edit = node.edit
						}
						if (aux.remove !== true) {
							aux.remove = node.remove
						}
					}
					else {
						aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
					}

					permissions.current = aux
					set_permissions_trigger(v => v + 1)

					if (Array.isArray(node.submenu) && node.submenu.length > 0) {
						await ver_submenu(node)
					}

				} else
					await ver_submenu(node)
			}
		}

		await handleSingleCheck(e, sidebar)
	}

	const carregar_permissoes = async () => {
		await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(endpoints.list, v) })

		if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {
			for await (let el of getTokenInfo().entity_profile) {
				await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(endpoints.list, v) })
			}
		}
	}

	const ensure_defaults = (d) => {
		const address_defaults = {
			localidade: '',
			country: '',
			address_detail: '',
		}

		if (!Array.isArray(d.addresses) || d.addresses.length === 0) {
			d.addresses = [{}]
		}
		d.addresses[0] = { ...address_defaults, ...d.addresses[0] }
		Object.keys(address_defaults).forEach(k => {
			if (d.addresses[0][k] === null || d.addresses[0][k] === undefined) {
				d.addresses[0][k] = address_defaults[k]
			}
		})

		const info_defaults = {
			name: '',
			tipo_competicao: '',
			modalidades: [],
			escaloes: [],
			epoca: EPOCA.obterEpocaAtual(),
			data_referencia: '',
			hora_referencia: '',
			tipo_classificacao: 'resultado',
			regulamento: [],
			foto: [],
			observacoes: '',
			clubes_inscritos: [],
			atletas_inscritos: [],
			classificacoes: [],
			responsavel: {
				identificacao: '',
				telefone: '',
				email: '',
			},
		}
		d.info = { ...info_defaults, ...d.info }
		Object.keys(info_defaults).forEach(k => {
			if (d.info[k] === null || d.info[k] === undefined) {
				d.info[k] = info_defaults[k]
			}
		})

		if (!d.info.data_referencia && d.info.data_inicio) {
			d.info.data_referencia = d.info.data_inicio
		}

		const eh_mapa_por_epoca = (valor) => {
			if (!valor || typeof valor !== 'object' || Array.isArray(valor)) return false
			const chaves = Object.keys(valor)
			return chaves.length === 0 || chaves.every(k => k.includes('/'))
		}
		const migrar_para_mapa_por_epoca = (valor, epoca_do_registo) => {
			if (eh_mapa_por_epoca(valor)) return valor
			if (Array.isArray(valor)) {
				return valor.length > 0 ? { [epoca_do_registo]: valor } : {}
			}
			if (valor && typeof valor === 'object' && Object.keys(valor).length > 0) {
				return { [epoca_do_registo]: valor }
			}
			return {}
		}
		const epoca_do_registo = d.info.epoca || info_defaults.epoca
		// d.info.clubes_inscritos = migrar_para_mapa_por_epoca(d.info.clubes_inscritos, epoca_do_registo)
		// d.info.atletas_inscritos = migrar_para_mapa_por_epoca(d.info.atletas_inscritos, epoca_do_registo)
		// d.info.classificacoes = migrar_para_mapa_por_epoca(d.info.classificacoes, epoca_do_registo)

		d.info.clubes_inscritos = d.info.clubes_inscritos
		d.info.atletas_inscritos = d.info.atletas_inscritos
		d.info.classificacoes = d.info.classificacoes

		d.info.responsavel = { ...info_defaults.responsavel, ...(d.info.responsavel || {}) }
		Object.keys(info_defaults.responsavel).forEach(k => {
			if (d.info.responsavel[k] === null || d.info.responsavel[k] === undefined) {
				d.info.responsavel[k] = ''
			}
		})

		return d
	}

	const clean_data = () => {
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		set_dados(dados.current = ensure_defaults(dados.current))
	}

	const fetch_id_info = async (id_serch) => {
		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = ensure_defaults(res.data[0]));
			})
			.catch(error => console.log(error))
	}

	const item_id = props?.location?.state?.item?.id
	const operation = props?.location?.state?.operation
	const tab_state = props?.location?.state?.tab

	useEffect(() => {
		clean_data();

		set_lang(localStorage.getItem('lang'))

		obter_paises_em_pt(set_countries)

		set_temporadas_lista([])
		set_jogos_lista([])
		setRedirect(false);

		const get_attr = async () => {
			let res_1 = await fetch_temporadas('temporada')
			let res_2 = await fetch_jogos('jogos')

			if (res_1.length > 0) {

				res_1 = order_array_desc(res_1)

				let res_aux_1 = res_1.map(el => ({
					id: el.id,
					label: el.name,
				}))

				set_temporadas_lista(res_aux_1)
			}

			if (res_2.length > 0) {

				res_2 = order_array_data_jogo_asc(res_2)
				res_2 = order_array_hora_jogo_asc(res_2)


				set_jogos_lista(res_2)
			}
		}

		if (operation === 'edit' && item_id) {
			set_is_edit(true)
			set_show_delete_button(true)

			Promise.all([get_attr(), fetch_id_info(item_id), carregar_permissoes()]).then(() => {
				setLoading(false)
			})
			return
		}

		clean_data()
		Promise.all([get_attr(), carregar_permissoes()]).then(() => {
			setLoading(false)
		})

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [item_id, operation])

	const handle_change_info = (e) => {
		const { name, value } = e.target;
		set_dados(dados.current.info[name] = value)
	}

	const handle_change_responsavel = (e) => {
		const { name, value } = e.target;
		set_dados(dados.current.info.responsavel[name] = value)
	}

	const handle_change_addresses = (e, addresses_index = 0) => {
		const { name, value } = e.target;
		set_dados(dados.current.addresses[addresses_index][name] = value)
	}

	const change_country = (e) => {
		set_dados(dados.current.addresses[0].country = e.value);
	}

	const change_modalidades = (selected) => {
		set_dados(dados.current.info.modalidades = selected || []);
	};

	const change_tipo_competicao = (selected) => {
		set_dados(dados.current.info.tipo_competicao = selected ? selected.value : '');
	};

	const change_tipo_classificacao = (selected) => {
		set_dados(dados.current.info.tipo_classificacao = selected ? selected.value : 'resultado');
	};

	const change_escaloes = (selected) => {
		set_dados(dados.current.info.escaloes = selected || []);
	};

	const change_epoca = (selected) => {


		console.log('selected', selected)

		set_dados(dados.current.info.epoca = selected ? {id: selected.value, name: selected.label} : '');

		console.log('dados.current.info.epoca', dados.current.info.epoca)


		set_selected_clube_inscrito(null);
	};


	const uploadFile = async (file, field) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'content')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/content/');

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then(async (res) => {

				var today_file = new Date()

				let i = Date.now()

				let x = {
					id: i,
					info: {
						companycode: getTokenInfo().companycode,
						type: res.data.mimetype,
						link: res.data.path + '/' + res.data.name,
						size: res.data.size,
						date: today_file
					},
					content: {
						name: file.name,
						description: '',
						lang: []
					}
				}

				const file_meta = {
					name: file.name,
					type: file.type,
					size: file.size,
					path: res.data.path,
					source_name: res.data.name,
					link: res.data.path + '' + res.data.name,
				};

				set_dados(dados.current.info[field] = [file_meta]);

				await reqPUT(api_crud_route, dados.current)
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				await reqPOST(`${api_crud_base}/multimedia`, x)
					.then(() => {
						let y2 = img_loader
						y2.pop()
						set_img_loader(y2)
						setRefresh(i)
					})
					.catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))

				return true
			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

	const onChangeHandlerFilesDoc = (e) => {
		const { files, dataset } = e.target;
		const { field } = dataset;

		let filesArray = Array.prototype.slice.call(files);
		let storedFiles = [];

		filesArray.forEach((v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				set_dados(dados.current.info[field] = [{
					name: v.name,
					type: v.type,
					size: v.size,
					link: '',
				}])
			}
			else {
				Swal.fire((language[lang].upload_file_error ?? 'Formato do ficheiro incorrecto: ') + v.name, '', 'info')
			}
		});

		if (storedFiles.length > 0) {
			let files_aux = files_doc
			files_aux.push({ files: storedFiles, field: field })
			set_files_doc(files_aux)
			setRefresh(refresh + 1)
		}
	}

	const uploadFilesDoc = async (files, field) => {
		await Promise.all(files.map(async (element) => {
			if (element.type === 'application/pdf') {
				await uploadFile(element, field)
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		}))
	}

	const handleDocRemove = (field) => {
		set_dados(dados.current.info[field] = [])
		setRefresh(refresh + 1)
	};

	const edit_element_tree_doc = (field, e) => {
		const { value } = e.target;
		if (Array.isArray(dados.current.info[field]) && dados.current.info[field][0]) {
			dados.current.info[field][0].name = value
			set_dados(dados.current.info[field])
			setRefresh(refresh + 1)
		}
	}

	const open_link = (url) => {
		if (url) window.open(url, '_blank');
	}

	const copy_clipboard = (url) => {
		if (!url) return
		navigator.clipboard.writeText(url)

		Swal.fire({
			icon: '',
			title: '',
			text: 'Copiado',
			showConfirmButton: false,
			timer: 1000
		})
	}

	const convertBase64 = async (file) => {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);

			fileReader.onload = () => {
				resolve(fileReader.result);
			};

			fileReader.onerror = (error) => {
				reject(error);
			};
		});
	};

	const onChangeHandlerFilesImage = async (e) => {
		const { files, dataset } = e.target;
		const { order, langid } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);
		let files_img_aux = image_base64

		let k = 0
		for await (let v of filesArray) {
			if ((v.type.includes('image/')) && (v.size < 10485760)) {

				await handle_compressed_image_upload(v, (valor) => storedFiles.push(valor))

				await convertBase64(v)
					.then((base64) => {

						if (files_img_aux[order] === undefined)
							files_img_aux[order] = []
						if (files_img_aux[order][langid] === undefined)
							files_img_aux[order][langid] = []

						files_img_aux[order][langid].push({ id: '1', langid: langid, name: v.name.split('.')[0] + '.webp', link: base64 })
						set_image_base64(files_img_aux)
						set_photo_base64(base64)
						setRefresh(refresh + Math.random())
					})

				if (filesArray.length === (k + 1)) {
					setRefresh(refresh + parseInt(v.size) + k)
				}

			}
			else {
				Swal.fire((language[lang].upload_image_error ?? 'Ficheiro de imagem inválido: ') + v.name, '', 'info')
			}

			k++
		}

		let files_aux = files_image
		files_aux.push({ files: storedFiles, order: order })
		set_files_image(files_aux)
	}

	const handleFileRemove = () => {
		set_dados(dados.current.info.foto = [])
		set_photo_base64('')
		set_image_base64([])
	};

	const uploadFilesImage = async (files) => {
		await Promise.all(files.map(async (element) => {
			if (element.type.includes('image/')) {

				let y = img_loader
				y.push('img')
				set_img_loader(y)

				await uploadFile(element, 'foto')
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		}))
	}

	const search_clubes_to_inscrever = async (term) => {
		setClubeLoading(true)

return

		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/Clube`)
			const t = (term || '').toLowerCase()
			const epoca_form = dados.current.info.epoca
			const clubes_da_epoca = dados.current.info.clubes_inscritos?.[epoca_form] || []
			const ja_inscritos = clubes_da_epoca.map(c => String(c.id))
			const filtered = (res.data || [])
				.filter(e => !ja_inscritos.includes(String(e.id)))
				.filter(e => {
					const nome = (e?.info?.name ?? e?.name ?? '').toLowerCase()
					return t === '' || nome.includes(t)
				})
			setClubeResults(filtered)
		} catch (error) {
			console.error('Erro ao pesquisar clubes:', error)
		} finally {
			setClubeLoading(false)
		}
	}

	useEffect(() => {
		if (showClubeModal) {
			search_clubes_to_inscrever(clubeSearch)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showClubeModal])

	const handle_clube_search_change = (e) => {
		const value = e.target.value
		setClubeSearch(value)
		search_clubes_to_inscrever(value)
	}

	const handleCloseClubeModal = () => {
		setShowClubeModal(false)
		setSelectedClubeToInscrever(null)
		setClubeSearch('')
	}

	const inscrever_clube = () => {
		if (!selectedClubeToInscrever) return

		const nome_clube = selectedClubeToInscrever?.info?.name ?? selectedClubeToInscrever?.name ?? ''

		Swal.fire({
			title: language[lang].inscrever_clube_title ?? 'Inscrever clube',
			html: `${language[lang].inscrever_clube_text ?? 'Confirma inscrever o clube'} <b>${nome_clube}</b> ${language[lang].inscrever_clube_text_2 ?? 'nesta competição?'}`,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].associar_confirm ?? 'Inscrever',
			cancelButtonText: language[lang].associar_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				const epoca_form = dados.current.info.epoca
				const atual = dados.current.info.clubes_inscritos?.[epoca_form] || []
				set_dados(dados.current.info.clubes_inscritos = {
					...(dados.current.info.clubes_inscritos || {}),
					[epoca_form]: [...atual, { id: selectedClubeToInscrever.id, label: nome_clube }]
				})
				handleCloseClubeModal()
			}
		})
	}

	const remover_clube_inscrito = (clube_id) => {
		Swal.fire({
			title: language[lang].remove_title ?? 'Remover',
			text: language[lang].remove_text ?? 'Confirma remover este clube da competição?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].remove_confirm ?? 'Remover',
			cancelButtonText: language[lang].remove_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				const epoca_form = dados.current.info.epoca
				const atual = dados.current.info.clubes_inscritos?.[epoca_form] || []
				set_dados(dados.current.info.clubes_inscritos = {
					...(dados.current.info.clubes_inscritos || {}),
					[epoca_form]: atual.filter(c => String(c.id) !== String(clube_id))
				})

				const classificacoes_da_epoca = { ...(dados.current.info.classificacoes?.[epoca_form] || {}) }
				delete classificacoes_da_epoca[clube_id]
				set_dados(dados.current.info.classificacoes = {
					...(dados.current.info.classificacoes || {}),
					[epoca_form]: classificacoes_da_epoca
				})

				if (String(selected_clube_inscrito?.id) === String(clube_id)) {
					set_selected_clube_inscrito(null)
				}
			}
		})
	}

	const search_atletas_to_inscrever = async (term) => {
		if (!selected_clube_inscrito) {
			setAtletaResults([])
			return
		}
		
return


		setAtletaLoading(true)
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/special/${getTokenInfo().companycode}/*`)
			const t = (term || '').toLowerCase()
			const epoca_form = dados.current.info.epoca
			const atletas_da_epoca = dados.current.info.atletas_inscritos || []
			const ja_inscritos = atletas_da_epoca.map(a => String(a.id))
			const modalidades_competicao = (dados.current.info.modalidades || []).map(m => m.value ?? m)
			const escaloes_competicao = (dados.current.info.escaloes || []).map(esc => esc.value ?? esc)

			const filtered = (res.data || [])
				.filter(e => !ja_inscritos.includes(String(e.id)))
				.filter(e => !clube_ids.has(String(e.id)))
				.filter(e => {
					const clube_entidade = e?.info?.clube ?? e?.clube
					const clube_entidade_id = clube_entidade?.id ?? clube_entidade
					const clube_entidade_label = clube_entidade?.label
					return String(clube_entidade_id) === String(selected_clube_inscrito.id)
						|| (clube_entidade_label && clube_entidade_label === selected_clube_inscrito.label)
				})
				.filter(e => {
					const nome = (e?.info?.name ?? e?.name ?? '').toLowerCase()
					return t === '' || nome.includes(t)
				})
				.filter(e => entidade_pratica_modalidade(e, modalidades_competicao))
				.filter(e => entidade_esta_no_escalao(e, modalidades_competicao, escaloes_competicao))

			setAtletaResults(filtered)
		} catch (error) {
			console.error('Erro ao pesquisar atletas:', error)
		} finally {
			setAtletaLoading(false)
		}
	}

	useEffect(() => {
		if (showAtletaModal) {
			search_atletas_to_inscrever(atletaSearch)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showAtletaModal, selected_clube_inscrito])

	const handle_atleta_search_change = (e) => {
		const value = e.target.value
		setAtletaSearch(value)
		search_atletas_to_inscrever(value)
	}

	const handleCloseAtletaModal = () => {
		setShowAtletaModal(false)
		setSelectedAtletaToInscrever(null)
		setAtletaSearch('')
	}

	const inscrever_atleta = () => {
		if (!selectedAtletaToInscrever || !selected_clube_inscrito) return

		const nome_atleta = selectedAtletaToInscrever?.info?.name ?? selectedAtletaToInscrever?.name ?? ''
		const numero_atleta = selectedAtletaToInscrever?.info?.numero_atleta ?? selectedAtletaToInscrever?.numero_atleta ?? ''
		const modalidades_competicao = (dados.current.info.modalidades || []).map(m => m.value ?? m)
		const overlapping = get_overlapping_modalidades(selectedAtletaToInscrever, modalidades_competicao)
		const modalidades_label = overlapping.map(v => modalidades_lista.find(o => o.value === v)?.label ?? v).join(', ')
		const escalao_atleta = calcular_escalao_entidade(selectedAtletaToInscrever, modalidades_competicao)

		Swal.fire({
			title: language[lang].inscrever_atleta_title ?? 'Inscrever atleta',
			html: `${language[lang].inscrever_atleta_text ?? 'Confirma inscrever o atleta'} <b>${nome_atleta}</b> ${language[lang].inscrever_clube_text_2 ?? 'nesta competição?'}`,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].associar_confirm ?? 'Inscrever',
			cancelButtonText: language[lang].associar_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				const epoca_form = dados.current.info.epoca
				const atual = dados.current.info.atletas_inscritos || []
				set_dados(dados.current.info.atletas_inscritos = {
					...(dados.current.info.atletas_inscritos || {}),
					[epoca_form]: [
					...atual,
					{
						id: selectedAtletaToInscrever.id,
						label: nome_atleta,
						numero_atleta: numero_atleta,
						escalao: escalao_atleta,
						modalidades: modalidades_label,
						clube_id: selected_clube_inscrito.id,
					}
				]
				})
				handleCloseAtletaModal()
			}
		})
	}

	const remover_atleta_inscrito = (atleta_id) => {
		Swal.fire({
			title: language[lang].remove_title ?? 'Remover',
			text: language[lang].remove_text ?? 'Confirma remover este atleta da competição?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].remove_confirm ?? 'Remover',
			cancelButtonText: language[lang].remove_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {

				const atual = dados.current.info.atletas_inscritos || []
				set_dados(dados.current.info.atletas_inscritos = atual.filter(a => String(a.id) !== String(atleta_id)))

			}
		})
	}

	const handle_change_classificacao = (clube_id, valor) => {
		const epoca_form = dados.current.info.epoca
		set_dados(dados.current.info.classificacoes = {
			...(dados.current.info.classificacoes || {}),
			[epoca_form]: {
				...(dados.current.info.classificacoes?.[epoca_form] || {}),
				[clube_id]: valor
			}
		})
	}

	const handle_ajustar_pontos = (clube_id, delta) => {
		const epoca_form = dados.current.info.epoca
		const atual = Number(dados.current.info.classificacoes?.[epoca_form]?.[clube_id]) || 0
		set_dados(dados.current.info.classificacoes = {
			...(dados.current.info.classificacoes || {}),
			[epoca_form]: {
				...(dados.current.info.classificacoes?.[epoca_form] || {}),
				[clube_id]: atual + delta
			}
		})
	}

	const handleSubmit = async (e) => {
		e.preventDefault();

		Swal.fire({
			title: is_edit ? (language[lang].edit_title ?? 'Editar') : (language[lang].insert_title ?? 'Inserir'),
			text: is_edit ? (language[lang].edit_text ?? 'Confirma a edição?') : (language[lang].insert_text ?? 'Confirma a inserção?'),
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: is_edit ? (language[lang].edit_confirm ?? 'Confirmar') : (language[lang].insert_confirm ?? 'Confirmar'),
			cancelButtonText: is_edit ? (language[lang].edit_cancel ?? 'Cancelar') : (language[lang].insert_cancel ?? 'Cancelar')
		}).then((result) => {
			if (result.isConfirmed) {

				const requestMethod = is_edit ? reqPUT : reqPOST

				requestMethod(`${api_crud_route}`, dados.current)
					.then(async (res) => {

						if (!is_edit) {
							const novo_id = res?.data?.id ?? res?.data?.[0]?.id ?? (typeof res?.data === 'string' ? res.data : undefined)
							if (novo_id) {
								set_dados(dados.current.id = novo_id)
							}
						}

						await Promise.all(
							files_image
								.filter(el_image => el_image !== null && el_image.files.length > 0)
								.map(el_image => uploadFilesImage(el_image.files))
						)
						set_files_image([])
						set_image_base64([])

						await Promise.all(
							files_doc
								.filter(el_doc => el_doc !== null)
								.map(el_doc => uploadFilesDoc(el_doc.files, el_doc.field))
						)
						set_files_doc([])

						if(!is_edit) {
							props.history.push(endpoints.list)
						}

					})
					.catch(() => Swal.fire(is_edit ? (language[lang].edit_error ?? 'Erro ao editar') : (language[lang].insert_error ?? 'Erro ao inserir'), '', 'info'))
			}
		})
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title ?? 'Eliminar',
			text: language[lang].delete_text ?? 'Confirma a eliminação?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm ?? 'Eliminar',
			cancelButtonText: language[lang].delete_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route + '/', { id: dados.current.id })
					.then(() => { props.history.push(endpoints.list); })
					.catch(() => Swal.fire(language[lang].delete_error ?? 'Erro ao eliminar', '', 'info'))
			}
		})
	};



	const handleSingleCheckActive = () => {
		set_dados(dados.current.info.active = !dados.current.info.active)
	}

	const handleSingleCheckAvailable = () => {
		console.log('dados.current.info', dados.current.info)
		set_dados(dados.current.info.available = !dados.current.info.available)
	}

	const get_team_logo = (id) => {

		let result = repo_img_link('nophoto.webp')
		let aux = clubes_da_epoca.find(e_c => parseInt(e_c.id) === parseInt(id))

		if(aux !== undefined) {
			if(aux.logo !== undefined && aux.logo !== null) {
				let aux_logo = JSON.parse(aux.logo)

				if(Array.isArray(aux_logo) && aux_logo.length > 0) {
					result = aux_logo[0]?.link
				}
			}
		}

		return result
	}

	useEffect(() => {
		let aux_clubes_epoca = []
		if(Array.isArray(dados?.current?.info?.atletas_inscritos) && dados.current.info.atletas_inscritos.length > 0) {
			dados.current.info.atletas_inscritos.forEach(el => {
				let aux = aux_clubes_epoca.find(e => parseInt(e.id) === parseInt(el.clube_id))
				if(aux === undefined) {
					let aux_2 = clubes.find(e => parseInt(e.id) === parseInt(el.clube_id))
					if(aux_2 !== undefined) {
						aux_clubes_epoca.push(aux_2)
					}
				}
			})
		}
		set_clubes_da_epoca(aux_clubes_epoca)

	}, [clubes, dados?.current?.info?.atletas_inscritos])

	const epoca_atual_calculada = EPOCA.obterEpocaAtual();
	const epocas_lista = temporadas_lista.map(t => ({ value: t.id, label: t.label }));
	const epoca_do_registo = dados.current?.info?.epoca || epoca_atual_calculada;
	// const pode_editar = true // EPOCA.podeEditar(epoca_do_registo, getTokenInfo().profile, epoca_atual_calculada);
	// const clubes_da_epoca = dados.current?.info?.clubes_inscritos || [];
	const atletas_da_epoca = dados.current?.info?.atletas_inscritos || [];
	const classificacoes_da_epoca = dados.current?.info?.classificacoes || {};
	const tipo_classificacao_atual = dados.current?.info?.tipo_classificacao || 'resultado';

	const clubes_classificacao_ordenados = tipo_classificacao_atual === 'pontos'
		? [...clubes_da_epoca].sort((a, b) => (Number(classificacoes_da_epoca[b.id]) || 0) - (Number(classificacoes_da_epoca[a.id]) || 0))
		: tipo_classificacao_atual === 'tempo'
			? [...clubes_da_epoca].sort((a, b) => tempo_para_segundos(classificacoes_da_epoca[a.id]) - tempo_para_segundos(classificacoes_da_epoca[b.id]))
			: clubes_da_epoca;

	const tem_clubes_inscritos = clubes_da_epoca.length > 0;
	const pode_gerir_inscricoes = !tem_clubes_inscritos || permissions.current?.remove === true;

	if (isloading) return <Loader />
	if (!dados.current) return null

	return isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:

			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].competicao ?? 'Competição'}</h2>
					<p>{language[lang].competicao ?? 'Competição'} / {dados.current.id !== '' ? (language[lang].entity_edit ?? 'Editar') : (language[lang].entity_new ?? 'Novo')}</p>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="mb-5 mb-xl-10">

								<div className="card">
									<div className="card-header border-0 d-flex justify-content-sm-between" aria-expanded="true" aria-controls="div_competition_info">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].dados_competicao ?? 'Dados da Competição'}</h3>
										</div>
										<div className="card-toolbar">
											<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
												<li className="nav-item">
													<a className={"btn btn-sm btn-secondary rounded-0 multi-item" +  (tab_state !== undefined && tab_state === 'games' ? '' : ' active')} data-bs-toggle="tab" href={"#tab_pane_info_language_0"}>{language[lang].tab_geral}</a>
												</li>
												<li className="nav-item">
													<a className={"btn btn-sm btn-secondary rounded-0 multi-item"} data-bs-toggle="tab" href={"#tab_pane_athelete_0"}>{language[lang].tab_atletas}</a>
												</li>
												{
												tipo_classificacao_atual === 'jogos' ?
													<li className="nav-item">
														<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (tab_state !== undefined && tab_state === 'games' ? ' active' : '')} data-bs-toggle="tab" href={"#tab_pane_games_0"}>{language[lang].tab_games}</a>
													</li>
												:
													null
												}
												{console.log('tipo_classificacao_atual', tipo_classificacao_atual)}
												{
												tipo_classificacao_atual === 'tempo' ?
													<li className="nav-item">
														<a className={"btn btn-sm btn-secondary rounded-0 multi-item"} data-bs-toggle="tab" href={"#tab_pane_time_0"}>{language[lang].tab_time}</a>
													</li>
												:
													null
												}
											</ul>
										</div>
									</div>

									<div className="card-body border-top p-4">
										<div className='tab-content'>

											<div id="tab_pane_info_language_0" className={"tab-pane" + (tab_state !== undefined && tab_state === 'games' ? '' : ' active')} role="tabpanel">
												<form id="form" onSubmit={handleSubmit}>
													<div className="card-body border-top p-4">
														<fieldset disabled={!pode_editar} style={{ border: 'none', padding: 0, margin: 0 }}>

															<div className="row g-3 mb-4">
																<div className="col-12 col-md-6">
																	<label className="form-label fw-bold fs-6">{language[lang].competicao ?? 'Competição'}</label>
																	<input type="text" name="name" value={dados.current.info.name} className="form-control rounded-0" placeholder={language[lang].competicao_placeholder ?? 'Nome da competição'} onChange={handle_change_info} required />
																</div>
																
																<div className="col-6 col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].tipo_classificacao ?? 'Tipo de Classificação'}</label>
																	<Select
																		className="div-select"
																		options={tipo_classificacao_lista}
																		value={tipo_classificacao_lista.find(o => o.value === tipo_classificacao_atual) ?? null}
																		placeholder={language[lang].select ?? 'Selecione'}
																		onChange={change_tipo_classificacao}
																		isDisabled={!pode_editar}
																	/>
																</div>

																<div className="col-6 col-md-2"> 
																	<div className="d-flex">
																		<div className="mb-3">
																			<label className="fs-6 fw-bold mb-2">{language[lang].field_available}</label>
																			<div className="input-group">
																				<label className="switch">
																					<input
																						id={'item-switch-available'}
																						name={"available"}
																						className=""
																						type="checkbox"
																						value={dados.current.info.available}
																						onChange={handleSingleCheckAvailable}
																						defaultChecked={dados.current.info.available}
																					/>
																					<span className="slider" htmlFor={'item-switch-available'}></span>
																				</label>
																			</div>
																		</div>
																		<div className="ms-3 mb-3">
																			<label className="fs-6 fw-bold mb-2">{language[lang].field_activo}</label>
																			<div className="input-group">
																				<label className="switch">
																					<input
																						id={'item-switch-active'}
																						name={"active"}
																						className=""
																						type="checkbox"
																						value={dados.current.info.active}
																						onChange={handleSingleCheckActive}
																						defaultChecked={dados.current.info.active}
																					/>
																					<span className="slider" htmlFor={'item-switch-active'}></span>
																				</label>
																			</div>
																		</div>
																		
																	</div>
																</div>
															</div>

															<div className="row g-3 mb-4">
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].tipo_competicao ?? 'Tipo de Competição'}</label>
																	<Select
																		className="div-select"
																		options={tipo_competicao_lista}
																		value={tipo_competicao_lista.find(o => o.value === dados.current.info.tipo_competicao) ?? null}
																		placeholder={language[lang].select ?? 'Selecione'}
																		onChange={change_tipo_competicao}
																		isDisabled={!pode_editar}
																	/>
																</div>
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].modalidades ?? 'Modalidades'}</label>
																	<Select
																		isMulti
																		className="div-select"
																		options={modalidades_lista}
																		value={
																			Array.isArray(dados.current.info.modalidades)
																				? dados.current.info.modalidades.map(m => ({ label: m.label ?? m, value: m.value ?? m }))
																				: []
																		}
																		placeholder={language[lang].select ?? 'Selecione'}
																		onChange={change_modalidades}
																		isDisabled={!pode_editar}
																	/>
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].escaloes ?? 'Escalão(ões)'}</label>
																	<Select
																		isMulti
																		className="div-select"
																		options={escaloes_lista}
																		value={
																			Array.isArray(dados.current.info.escaloes)
																				? dados.current.info.escaloes.map(m => ({ label: m.label ?? m, value: m.value ?? m }))
																				: []
																		}
																		placeholder={language[lang].select ?? 'Selecione'}
																		onChange={change_escaloes}
																		isDisabled={!pode_editar}
																	/>
																</div>
															</div>

															<div className="row g-3 mb-4">
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].epoca ?? 'Época'}</label>
																	<Select
																		className="div-select"
																		options={epocas_lista}
																		value={epocas_lista.find(o => o.value === dados.current.info?.epoca?.id) ?? { value: dados.current?.info?.id, label: dados.current.info?.epoca?.name }}
																		placeholder={language[lang].select ?? 'Selecione'}
																		onChange={change_epoca}
																		isDisabled={!pode_editar}
																	/>
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].data_referencia ?? 'Data de início'}</label>
																	<input type="date" name="data_referencia" value={dados.current.info.data_referencia} className="form-control rounded-0" onChange={handle_change_info} />
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].hora_referencia ?? 'Hora de início'}</label>
																	<input type="time" name="hora_referencia" value={dados.current.info.hora_referencia} className="form-control rounded-0" onChange={handle_change_info} />
																</div>
															</div>

															<hr className="my-4" />

															<div className="row g-3 mb-4">
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].local_competicao ?? 'Local da Competição'}</label>
																	<input
																		type="text"
																		name="localidade_competicao"
																		value={dados.current.info.localidade_competicao}
																		className="form-control rounded-0"
																		placeholder={language[lang].local_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].local}</label>
																	<input
																		type="text"
																		name="localidade"
																		value={dados.current.info.localidade}
																		className="form-control rounded-0"
																		placeholder={language[lang].local_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].country}</label>
																	<input
																		type="text"
																		name="country"
																		value={dados.current.info.country}
																		className="form-control rounded-0"
																		placeholder={language[lang].country_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>
															</div>

															<hr className="my-4" />

															<div className="row g-3 mb-4">
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].responsavel_identificacao ?? 'Identi. Responsável'}</label>
																	<input type="text" name="identificacao" value={dados.current.info.responsavel.identificacao ?? ''} className="form-control rounded-0" onChange={handle_change_responsavel} />
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].responsavel_telefone ?? 'Tel Responsável'}</label>
																	<PhoneInput
																		defaultCountry="PT"
																		className="form-control rounded-0"
																		value={dados.current.info.responsavel.telefone || null}
																		onChange={(valor) => set_dados(dados.current.info.responsavel.telefone = valor)}
																		disabled={!pode_editar}
																	/>
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].responsavel_email ?? 'e-mail Responsável'}</label>
																	<input type="email" name="email" pattern={pattern_email} value={dados.current.info.responsavel.email ?? ''} className="form-control rounded-0" onChange={handle_change_responsavel} />
																</div>
															</div>

															<hr className="my-4" />

															<div className="row g-3 mb-4">
																<div className="col-md-4">
																	<DocUploadField
																		field="regulamento"
																		label={language[lang].regulamento ?? 'Regulamento'}
																		dados={dados}
																		language={language}
																		lang={lang}
																		onChangeHandlerFilesDoc={onChangeHandlerFilesDoc}
																		handleDocRemove={handleDocRemove}
																		edit_element_tree_doc={edit_element_tree_doc}
																		open_link={open_link}
																		copy_clipboard={copy_clipboard}
																	/>
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6 d-block">{language[lang].foto ?? 'Foto / Cartaz'}</label>
																	<div className="p-3 h-100">
																		<ul className="list-unstyled d-flex flex-wrap gap-3 mt-1 justify-content-center">
																			{
																				photo_base64 !== '' ?
																					<img
																						src={photo_base64}
																						className="img-fluid rounded"
																						alt="Uploaded"
																						style={{ width: "120px", height: "120px", objectFit: "cover" }}
																					/>
																					:
																					dados?.current?.info?.foto?.length > 0 ? (
																						dados.current.info.foto.map((file, index) => {
																							const imageURL = file.link || URL.createObjectURL(file);
																							return (
																								<li key={index} className="d-flex flex-column align-items-center">
																									<img
																										src={imageURL}
																										className="img-fluid rounded"
																										alt="Uploaded"
																										style={{ width: "120px", height: "120px", objectFit: "cover", cursor: file.link ? 'pointer' : 'default' }}
																										onClick={() => file.link && open_link(file.link)}
																									/>
																									<small className="mt-2 text-muted">{file.name || 'Imagem'}</small>
																								</li>
																							);
																						})
																					) : (
																						<li className="text-muted">{language[lang].noPhoto ?? 'Sem foto'}</li>
																					)}
																		</ul>

																		<div className="d-flex justify-content-center mt-3 gap-2">
																			<input
																				type="file"
																				accept="image/*"
																				onChange={onChangeHandlerFilesImage}
																				data-order={1}
																				data-langid={'1'}
																				data-type={'image'}
																				className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																				id="foto-upload"
																			/>

																			<label htmlFor="foto-upload" className="btn btn-outline-primary btn-sm rounded-0">
																				{language[lang].logo_choose ?? 'Escolher ficheiro'}
																			</label>

																			{dados?.current?.info?.foto?.length > 0 && dados.current.info.foto[0].link && (
																				<button
																					type="button"
																					className="btn btn-sm btn-outline-primary rounded-0"
																					onClick={() => open_link(dados.current.info.foto[0].link)}
																					title={language[lang].view ?? 'Ver'}
																				>
																					<i className="bi bi-eye"></i>
																				</button>
																			)}

																			{dados?.current?.info?.foto?.length > 0 && (
																				<button
																					type="button"
																					className="btn btn-sm btn-danger rounded-0"
																					onClick={handleFileRemove}
																				>
																					<i className="bi bi-x-lg"></i>
																				</button>
																			)}
																		</div>
																	</div>
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].observacoes ?? 'Observações'}</label>
																	<textarea name="observacoes" value={dados.current.info.observacoes} className="form-control rounded-0" rows="6" onChange={handle_change_info} />
																</div>
															</div>

														</fieldset>
													</div>
												</form>
											</div>
							
											<div id="tab_pane_athelete_0" className="tab-pane" role="tabpanel">	
												<div className="card">
													<div className="card-header border-0">
														<div className="card-title m-0">
															<h3 className="fw-bolder m-0">{language[lang].tab_atletas}</h3>
														</div>
													</div>
													<div className="card-body border-top p-4">
														<div className="div-table">

															<div className='col-12'>
																<div className='row'>
																	{
																	clubes_da_epoca !== undefined && clubes_da_epoca !== null ?
																		clubes_da_epoca.map((e, k) => {
																			return (
																				<div className='col-6 col-md-4'>
																					<div className='table-body table-responsive'>
																						<table className='table table-hover table-bordered align-middle'>
																							<thead>
																								<tr>
																									<th className='lh-lg p-3 text-end text-nowrap'>{language[lang].numero_licenca}</th>
																									<th className='lh-lg p-3'>{language[lang].name}</th>
																									<th className='lh-lg p-3 text-center'>{language[lang].clube}</th>
																								</tr>
																							</thead>
																							<tbody>
																								{
																								dados.current.info.atletas_inscritos.map((e_2, k_2) => {
																									if(parseInt(e.id) === parseInt(e_2.clube_id) && (parseInt(e_2.paid) === 1)) {
																										return (
																											<tr key={k + '_' + k_2}>
																												<td className='p-3 text-end'>{e_2.numero_licenca}</td>
																												<td className='p-3'>{e_2.label}</td>
																												<td className='p-3 text-center'>{e.name}</td>
																											</tr>
																										)
																									}
																								})
																								}
																							</tbody>
																						</table>
																					</div>
																				</div>
																			)
																		})
																	:
																		null
																	}
																	{
																	dados.current.info.atletas_inscritos.filter(e => (e.clube_id === '' && parseInt(e.paid) === 1)).length > 0 ?  
																		[''].map((e, k) => {
																			return (
																				<div className='col-6 col-md-4'>
																					<div className='table-body table-responsive'>
																						<table className='table table-hover table-bordered align-middle'>
																							<thead>
																								<tr>
																									<th className='lh-lg p-3 text-end text-nowrap'>{language[lang].numero_licenca}</th>
																									<th className='lh-lg p-3'>{language[lang].atleta}</th>
																									<th className='lh-lg p-3 text-center'>{language[lang].clube}</th>
																								</tr>
																							</thead>
																							<tbody>
																								{
																								dados.current.info.atletas_inscritos.map((e_2, k_2) => {
																									if((e) === (e_2.clube_id) && (parseInt(e_2.paid) === 1)) {
																										if(k_2 === 0) {
																										return (
																											<tr key={k + '_' + k_2}>
																												<td className='p-3 text-end'>{e_2.numero_licenca}</td>
																												<td className='p-3'>{e_2.label}</td>
																												<td className='p-3 text-center'>{language[lang].individual}</td>
																											</tr>
																										)
																										}
																									}
																									else {
																										return null
																									}
																								})
																								}
																							</tbody>
																						</table>
																					</div>
																				</div>
																			)
																		})
																	:
																		null
																	}
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>

											{
											tipo_classificacao_atual === 'jogos' ?
												<div id="tab_pane_games_0" className={"tab-pane" + (tab_state !== undefined && tab_state === 'games' ? ' active' : '')} role="tabpanel">	
													<div className="card">
														<div className="card-header border-0">
															<div className="card-title m-0">
																<h3 className="fw-bolder m-0">{language[lang].tab_games}</h3>
															</div>
														</div>
														<div className="card-body">
															<div className="row">

																<div className='col-12 mb-4'>
																	<Link className={"btn btn-primary"} to={{ pathname: '/intranet_jogos_regist', state: { go_back_operation : 'intranet_competicoes_regist', item_go_back: dados.current, equipas: clubes_da_epoca } }} >
																		<i className="bi bi-plus me-2"></i>
																		<span>{language[lang].add_game}</span>
																	</Link>
																</div>

																<div className='col-12'>
																	<div className='row justify-content-start'>
																		{console.log('jogos_lista', jogos_lista)}
																		{
																		jogos_lista !== undefined && jogos_lista !== null ?
																			jogos_lista.map((e, k) => {
																				return (
																					<div key={k} className="col-md-6 col-lg-4">
																						{/* <!-- Início do Card do Jogo --> */}
																						<div className="card shadow-sm text-center border-0 rounded-4">
																							{/* <!-- Cabeçalho: Nome do Torneio / Data --> */}
																							<div className="card-header bg-dark text-white rounded-top-4 py-2 small fw-bold text-uppercase tracking-wider">
																								{translate(e.info.name, 'pt')}
																							</div>
																							{/* <!-- Corpo do Card: Equipas e Resultado --> */}
																							<div className="card-body py-4">
																								<div className="row align-items-center">

																									{/* <!-- Equipa da Casa --> */}
																									{
																									e?.info?.equipa_casa !== undefined && e?.info?.equipa_casa !== null ?
																										<div className="col-4">
																											<img src={get_team_logo(e.info.equipa_casa.id)} alt={e.info.equipa_casa.label} className="img-fluid mb-2 rounded-circle bg-light p-2" />
																											<h6 className="card-title mb-0 text-truncate- fw-bold">
																												{e.info.equipa_casa.label}
																												{
																												e?.info?.equipa_visitante !== undefined && e?.info?.equipa_visitante !== null && parseInt(e.info.equipa_casa.id) === parseInt(e.info.equipa_visitante.id) ?
																													(e?.info?.equipa_casa_?.label !== undefined && e?.info?.equipa_casa_?.label !== null ? ' "' + e.info.equipa_casa_.label + '"' : '')
																												:
																													null
																												}
																											</h6>
																										</div>
																									:
																										<div className="col-4"></div>
																									}
																									{/* <!-- Placar / Estado do Jogo --> */}
																									<div className="col-4 px-0">
																										<div className="d-flex flex-column align-items-center">
																											<span className="badge bg-danger text-uppercase fw-bold mb-2 animate-pulse small d-none">Ao Vivo</span>
																											<h2 className="fw-bolder mb-0 text-dark">{e?.info?.golos_periodo?.casa !== undefined ? soma_periodos(e.info.golos_periodo.casa) : ''} <i className="bi bi-x mx-1"></i> {e?.info?.golos_periodo?.visitante !== undefined ? soma_periodos(e.info.golos_periodo.visitante) : ''}</h2>
																											<small className="text-muted mt-1 fw-medium d-none">65'</small>

																											<small className="text-muted- mt-1 fw-medium mt-4">{e.info.data_jogo} {e.info.hora_inicio}</small>
																										</div>
																									</div>
																									{/* <!-- Equipa Visitante --> */}
																									{
																									e?.info?.equipa_visitante !== undefined && e?.info?.equipa_visitante !== null ?
																										<div className="col-4">
																											<img src={get_team_logo(e.info.equipa_visitante.id)} alt={e.info.equipa_visitante.label} className="img-fluid mb-2 rounded-circle bg-light p-2" />
																											<h6 className="card-title mb-0 text-truncate- fw-bold">
																												{e.info.equipa_visitante.label}
																												{
																												e?.info?.equipa_casa !== undefined && e?.info?.equipa_casa !== null && parseInt(e.info.equipa_casa.id) === parseInt(e.info.equipa_visitante.id) ?
																													(e?.info?.equipa_visitante_?.label !== undefined && e?.info?.equipa_visitante_?.label !== null ? ' "' + e.info.equipa_visitante_.label + '"' : '')
																												:
																													null
																												}	
																											</h6>
																										</div>
																									:
																										<div className="col-4"></div>
																									}
																								</div>
																							</div>
																							{/* <!-- Rodapé: Detalhes Extra ou Botão de Bilhetes --> */}
																							<div className="card-footer bg-light border-top-0 rounded-bottom-4 py-3">
																								<div className="d-grid">
																									<Link className={"btn btn-secondary btn-sm fw-bold rounded-pill"} to={{ pathname: '/intranet_jogos_view', state: { item: e, operation: 'view', go_back_operation : 'intranet_competicoes_regist', item_go_back: dados.current, equipas: clubes_da_epoca } }} >
																										<span>{language[lang].see_game_stats}</span>
																									</Link>
																									<Link className={"btn btn-primary btn-sm fw-bold rounded-pill mt-2"} to={{ pathname: '/intranet_jogos_regist', state: { item: e, operation: 'edit', go_back_operation : 'intranet_competicoes_regist', item_go_back: dados.current, equipas: clubes_da_epoca } }} >
																										<span>{language[lang].edit_game}</span>
																									</Link>
																								</div>
																							</div>
																						</div>
																						{/* <!-- Fim do Card --> */}
	
																					</div>
																				)
																			})
																		:
																			null
																		}
																	</div>
																</div>

															</div>
														</div>
													</div>
												</div>
											:
												null
											}

											{
											tipo_classificacao_atual === 'tempo' ?
												<div id="tab_pane_time_0" className={"tab-pane"} role="tabpanel">	
													<div className="card">
														<div className="card-header border-0">
															<div className="card-title m-0">
																<h3 className="fw-bolder m-0">{language[lang].tab_time}</h3>
															</div>
														</div>
														<div className="card-body">
															<div className="row">

																<div className='col-12'>
																	<div className='table-body table-responsive'>
																		<table className='table table-hover table-bordered align-middle'>
																			<thead>
																				<tr>
																					<th></th>
																					<th className='lh-lg p-3 text-end text-nowrap'>{language[lang].dorsal}</th>
																					<th className='lh-lg p-3 text-end text-nowrap'>{language[lang].numero_licenca}</th>
																					<th className='lh-lg p-3'>{language[lang].name}</th>
																					<th className='lh-lg p-3'>{language[lang].year}</th>
																					<th className='lh-lg p-3 text-center'>{language[lang].clube}</th>
																					<th className='lh-lg p-3 text-center'>{language[lang].first_run}</th>
																					<th className='lh-lg p-3 text-center'>{language[lang].second_run}</th>
																					<th className='lh-lg p-3 text-center'>{language[lang].total_time}</th>
																					<th className='lh-lg p-3 text-center'>{language[lang].diff_time}</th>
																				</tr>
																			</thead>
																			<tbody>
																				{console.log('dados.current.info.atletas_inscritos', dados.current.info.atletas_inscritos)}
																				{
																				dados.current.info.atletas_inscritos.map((e, k) => {
																					if(parseInt(e.paid) === 1) {
																						return (
																							<tr key={k}>
																								<td className='p-3 text-end'></td>
																								<td className='p-3 text-end'>{e.dorsal}</td>
																								<td className='p-3 text-end'>{e.numero_licenca}</td>
																								<td className='p-3'>{e.label}</td>
																								<td className='p-3 text-center'></td>
																								<td className='p-3 text-center'></td>
																								<td className='p-3 text-center'></td>
																								<td className='p-3 text-center'></td>
																								<td className='p-3 text-center'></td>
																								<td className='p-3 text-center'></td>
																							</tr>
																						)
																					}
																				})
																				}
																			</tbody>
																		</table>
																	</div>
																</div>

															</div>
														</div>
													</div>
												</div>
											:
												null
											}

										</div>
									</div>
								</div>

								{is_edit && false && (
									<>
										<div className="card mt-5">
											<div className="card-header border-0 d-flex justify-content-between align-items-center">
												<div className="card-title m-0">
													<h3 className="fw-bolder m-0">{language[lang].clubes_inscritos ?? 'Clubes Inscritos'} — {dados.current.info?.epoca?.name}</h3>
												</div>
												<button type="button" className="btn btn-sm btn-primary" onClick={() => setShowClubeModal(true)} disabled={!pode_gerir_inscricoes}>
													<i className="bi bi-plus-circle me-2"></i>
													{language[lang].inscrever_clube ?? 'Inscrever Clube'}
												</button>
											</div>
											<div className="card-body border-top p-4">
												{!pode_gerir_inscricoes && (
													<p className="text-muted small mb-3">
														{language[lang].apenas_admin_edita ?? 'Já existem clubes inscritos nesta época — só um administrador pode alterar esta lista.'}
													</p>
												)}
												<p className="text-muted small mb-3">
													{language[lang].selecionar_clube_hint ?? 'Selecione um clube na lista abaixo para gerir os atletas inscritos desse clube.'}
												</p>
												<table className="table table-bordered align-middle">
													<thead>
														<tr>
															<th>{language[lang].clube ?? 'Clube'}</th>
															<th></th>
														</tr>
													</thead>
													<tbody>
														{clubes_da_epoca.length > 0 ? (
															clubes_da_epoca.map((el, k) => {
																const is_selected = String(selected_clube_inscrito?.id) === String(el.id)
																return (
																	<tr
																		key={el.id ?? k}
																		// onClick={() => set_selected_clube_inscrito(el)}
																		// style={{ cursor: 'pointer', backgroundColor: is_selected ? '#e7f3ff' : undefined }}
																	>
																		<td className='w-75'>
																			{is_selected && <i className="bi bi-check-circle-fill me-2" style={{ color: '#0095e8' }}></i>}
																			{el.name}
																		</td>
																		<td className="text-end">
																				<button
																					type="button"
																					className="btn btn-sm btn-primary rounded-0 me-2"
																					onClick={(e) => { set_selected_clube_inscrito(el) }}
																				>
																					{language[lang].see ?? 'Ver atletas'}
																				</button>
																			{pode_gerir_inscricoes && (
																				<button
																					type="button"
																					className="btn btn-sm btn-danger rounded-0"
																					onClick={(e) => { e.stopPropagation(); remover_clube_inscrito(el.id) }}
																				>
																					{language[lang].remove ?? 'Remover'}
																				</button>
																			)}
																		</td>
																	</tr>
																)
															})
														) : (
															<tr>
																<td colSpan="2" className="text-center text-muted">{language[lang].sem_registos ?? 'Sem registos'}</td>
															</tr>
														)}
													</tbody>
												</table>
											</div>
										</div>

										{selected_clube_inscrito && (
											<div className="card mt-5">
												<div className="card-header border-0 d-flex justify-content-between align-items-center">
													<div className="card-title m-0">
														<h3 className="fw-bolder m-0">
															{language[lang].atletas_inscritos ?? 'Atletas Inscritos'} — {selected_clube_inscrito.label} ({dados.current.info?.epoca?.name})
														</h3>
													</div>
													<button type="button" className="btn btn-sm btn-primary" onClick={() => setShowAtletaModal(true)} disabled={!pode_gerir_inscricoes}>
														<i className="bi bi-plus-circle me-2"></i>
														{language[lang].inscrever_atletas ?? 'Inscrever Atletas'}
													</button>
												</div>
												<div className="card-body border-top p-4">
													<table className="table table-bordered align-middle">
														<thead>
															<tr>
																<th>{language[lang].numero_atleta ?? 'Nº de Atleta'}</th>
																<th>{language[lang].name ?? 'Nome'}</th>
																<th>{language[lang].escalao ?? 'Escalão'}</th>
																<th>{language[lang].modalidades ?? 'Modalidades'}</th>
																<th></th>
															</tr>
														</thead>
														<tbody>
															{(() => {
																const atletas_do_clube = atletas_da_epoca
																	.filter(el => String(el.clube_id) === String(selected_clube_inscrito.id))

																if (atletas_do_clube.length === 0) {
																	return (
																		<tr>
																			<td colSpan="5" className="text-center text-muted">{language[lang].sem_registos ?? 'Sem registos'}</td>
																		</tr>
																	)
																}

																return atletas_do_clube.map((el, k) => (
																	<tr key={el.id ?? k}>
																		<td>{el.numero_licenca}</td>
																		<td>{el.label}</td>
																		<td>{el.escalao || '-'}</td>
																		<td>{el.modalidades || '-'}</td>
																		<td className="text-end">
																			{pode_gerir_inscricoes && (
																				<button type="button" className="btn btn-sm btn-danger rounded-0" onClick={() => remover_atleta_inscrito(el.id)}>
																					{language[lang].remove ?? 'Remover'}
																				</button>
																			)}
																		</td>
																	</tr>
																))
															})()}
														</tbody>
													</table>
												</div>
											</div>
										)}

										<div className="card mt-5">
											<div className="card-header border-0">
												<div className="card-title m-0">
													<h3 className="fw-bolder m-0">{language[lang].classificacoes ?? 'Classificações'} — {dados.current.info?.epoca?.name}</h3>
												</div>
											</div>
											<div className="card-body border-top p-4">
												<div className="row g-3 mb-4">
													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].tipo_classificacao ?? 'Tipo de Classificação'}</label>
														<Select
															className="div-select"
															options={tipo_classificacao_lista}
															value={tipo_classificacao_lista.find(o => o.value === tipo_classificacao_atual) ?? null}
															placeholder={language[lang].select ?? 'Selecione'}
															onChange={change_tipo_classificacao}
															isDisabled={!pode_editar}
														/>
													</div>
												</div>

												<table className="table table-bordered align-middle">
													<thead>
														<tr>
															{tipo_classificacao_atual !== 'resultado' && <th style={{ width: '50px' }}>#</th>}
															<th>{language[lang].clube ?? 'Clube'}</th>
															<th>{language[lang].classificacao ?? 'Classificação'}</th>
														</tr>
													</thead>
													<tbody>
														{clubes_classificacao_ordenados.length > 0 ? (
															clubes_classificacao_ordenados.map((el, k) => (
																<tr key={el.id ?? k}>
																	{tipo_classificacao_atual !== 'resultado' && <td>{k + 1}</td>}
																	<td>{el.name}</td>
																	<td>
																		{tipo_classificacao_atual === 'pontos' && (
																			<div className="d-flex align-items-center gap-2">
																				<button
																					type="button"
																					className="btn btn-sm btn-outline-secondary"
																					disabled={!pode_gerir_inscricoes}
																					onClick={() => handle_ajustar_pontos(el.id, -1)}
																				>
																					−
																				</button>
																				<input
																					type="number"
																					className="form-control form-control-sm rounded-0 text-center"
																					style={{ width: '80px' }}
																					value={classificacoes_da_epoca[el.id] ?? 0}
																					onChange={(e) => handle_change_classificacao(el.id, e.target.value === '' ? 0 : Number(e.target.value))}
																					disabled={!pode_gerir_inscricoes}
																				/>
																				<button
																					type="button"
																					className="btn btn-sm btn-outline-secondary"
																					disabled={!pode_gerir_inscricoes}
																					onClick={() => handle_ajustar_pontos(el.id, 1)}
																				>
																					+
																				</button>
																			</div>
																		)}
																		{tipo_classificacao_atual === 'tempo' && (
																			<input
																				type="text"
																				className="form-control rounded-0"
																				style={{ width: '140px' }}
																				value={classificacoes_da_epoca[el.id] ?? ''}
																				onChange={(e) => handle_change_classificacao(el.id, e.target.value)}
																				placeholder="hh:mm:ss"
																				disabled={!pode_gerir_inscricoes}
																			/>
																		)}
																		{tipo_classificacao_atual === 'resultado' && (
																			<input
																				type="text"
																				className="form-control rounded-0"
																				value={classificacoes_da_epoca[el.id] ?? ''}
																				onChange={(e) => handle_change_classificacao(el.id, e.target.value)}
																				placeholder={language[lang].classificacao_placeholder ?? 'Posição'}
																				disabled={!pode_gerir_inscricoes}
																			/>
																		)}
																	</td>
																</tr>
															))
														) : (
															<tr>
																<td colSpan={tipo_classificacao_atual !== 'resultado' ? 3 : 2} className="text-center text-muted">{language[lang].sem_registos ?? 'Sem registos'}</td>
															</tr>
														)}
													</tbody>
												</table>
											</div>
										</div>
									</>
								)}

								{showClubeModal && false && (
									<div style={modalStyles.modalOverlay} onClick={handleCloseClubeModal}>
										<div style={modalStyles.modalContent} onClick={(e) => e.stopPropagation()}>
											<div style={modalStyles.taskListContainer}>
												<label className="form-label fw-bold fs-6">{language[lang].pesquisar_clube ?? 'Pesquisar Clube'}</label>
												<input
													type="text"
													className="form-control mb-3"
													placeholder={language[lang].pesquisar_entidade_placeholder ?? 'Pesquisar por nome...'}
													value={clubeSearch}
													onChange={handle_clube_search_change}
												/>

												<select
													className="form-select"
													size={8}
													value={selectedClubeToInscrever?.id ?? ''}
													onChange={(e) => {
														const found = clubeResults.find(el => String(el.id) === String(e.target.value))
														setSelectedClubeToInscrever(found ?? null)
													}}
												>
													<option value="">
														{clubeLoading ? (language[lang].loading ?? 'A carregar...') : (language[lang].field_choose ?? 'Selecione')}
													</option>
													{clubeResults.map((el, k) => (
														<option key={el.id ?? k} value={el.id}>
															{el.info?.name ?? el.name}
														</option>
													))}
												</select>
											</div>

											<div style={modalStyles.buttonContainer}>
												<button type="button" onClick={handleCloseClubeModal}>
													{language[lang].cancel ?? 'Cancelar'}
												</button>
												<button
													type="button"
													style={{ ...modalStyles.closeButton, marginLeft: '10px', backgroundColor: color.corPrimaria?.hexa ?? '#0095e8', color: '#FFF' }}
													disabled={!selectedClubeToInscrever}
													onClick={inscrever_clube}
												>
													{language[lang].inscrever_clube ?? 'Inscrever'}
												</button>
											</div>
										</div>
									</div>
								)}

								{showAtletaModal && false && (
									<div style={modalStyles.modalOverlay} onClick={handleCloseAtletaModal}>
										<div style={modalStyles.modalContent} onClick={(e) => e.stopPropagation()}>
											<div style={modalStyles.taskListContainer}>
												<label className="form-label fw-bold fs-6">{language[lang].pesquisar_atleta ?? 'Pesquisar Atleta'}</label>
												<input
													type="text"
													className="form-control mb-3"
													placeholder={language[lang].pesquisar_entidade_placeholder ?? 'Pesquisar por nome...'}
													value={atletaSearch}
													onChange={handle_atleta_search_change}
												/>

												<select
													className="form-select"
													size={8}
													value={selectedAtletaToInscrever?.id ?? ''}
													onChange={(e) => {
														const found = atletaResults.find(el => String(el.id) === String(e.target.value))
														setSelectedAtletaToInscrever(found ?? null)
													}}
												>
													<option value="">
														{atletaLoading ? (language[lang].loading ?? 'A carregar...') : (language[lang].field_choose ?? 'Selecione')}
													</option>
													{atletaResults.map((el, k) => (
														<option key={el.id ?? k} value={el.id}>
															{el.info?.name ?? el.name}
														</option>
													))}
												</select>
											</div>

											<div style={modalStyles.buttonContainer}>
												<button type="button" onClick={handleCloseAtletaModal}>
													{language[lang].cancel ?? 'Cancelar'}
												</button>
												<button
													type="button"
													style={{ ...modalStyles.closeButton, marginLeft: '10px', backgroundColor: color.corPrimaria?.hexa ?? '#0095e8', color: '#FFF' }}
													disabled={!selectedAtletaToInscrever}
													onClick={inscrever_atleta}
												>
													{language[lang].inscrever_atletas ?? 'Inscrever'}
												</button>
											</div>
										</div>
									</div>
								)}

							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}>
										<i className="bi bi-chevron-left me-2"></i>
										<span>{language[lang].back ?? 'Voltar'}</span>
									</Link>
								</li>
								<li className={"nav-item " + (show_delete_button && pode_editar ? '' : 'd-none')}>
									<button type="button" onClick={() => apagar()} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete ?? 'Eliminar'}</span>
									</button>
								</li>
								{pode_editar && (
									<li className="nav-item">
										<button type="submit" form="form" className="nav-link">
											<i className="bi bi-floppy me-2"></i>
											<span>{language[lang].save ?? 'Gravar'}</span>
										</button>
									</li>
								)}
							</ul>
						</div>
					</nav>
				</div>
			</main>
}

function DocUploadField({ field, label, dados, language, lang, onChangeHandlerFilesDoc, handleDocRemove, edit_element_tree_doc, open_link, copy_clipboard }) {
	const current = dados?.current?.info?.[field];
	const hasFile = Array.isArray(current) && current.length > 0;
	const treeData = hasFile ? [{ id: `${field}-1`, title: current[0].name, link: current[0].link, visible: true }] : [];

	return (
		<div className="h-100">
			<label className="form-label fw-bold fs-6 d-block mb-3">{label}</label>

			<div className="mb-2">
				<input
					type="file"
					accept="application/pdf"
					data-field={field}
					onChange={onChangeHandlerFilesDoc}
					className="d-none"
					id={`doc-upload-${field}`}
				/>
				<label htmlFor={`doc-upload-${field}`} className="btn btn-outline-primary btn-sm">
					{language[lang].doc_choose ?? 'Escolher ficheiro'}
				</label>
			</div>

			{hasFile ? (
				<SortableTree
					isVirtualized={false}
					treeData={treeData}
					maxDepth={1}
					canDrag={false}
					onChange={() => { }}
					getNodeKey={({ node }) => node.id}
					generateNodeProps={extendedNode => ({
						title: (
							<input
								type="text"
								className="form-control form-control-sm rounded-0"
								defaultValue={extendedNode.node.title}
								onBlur={(e) => edit_element_tree_doc(field, e)}
							/>
						),
						buttons: [
							<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
							<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
							<button type="button" onClick={() => handleDocRemove(field)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
						],
					})}
				/>
			) : (
				<div className="text-muted mb-2">{language[lang].noFile ?? 'Sem ficheiro'}</div>
			)}
		</div>
	);
}